import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-check-red",
  "use": "icon-check-red-usage",
  "viewBox": "0 0 13.51 14.55",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13.51 14.55\" id=\"icon-check-red\"><defs><style>#icon-check-red .cls-1{fill:none;stroke:#ff4a68;stroke-miterlimit:10;stroke-width:3px;}</style></defs><g id=\"icon-check-red_圖層_2\" data-name=\"圖層 2\"><g id=\"icon-check-red_細項1\"><polyline class=\"cls-1\" points=\"1.25 5.8 5.25 11.8 12.25 0.81\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol